import React from "react";
import { makeStyles, createStyles } from "@mui/styles";
import ArrowRightIcon from "@mui/icons-material/ArrowForwardOutlined";
import ArrowLeftIcon from "@mui/icons-material/ArrowBackOutlined";
import Button from "components/common/ButtonBase";
import { config } from "config";

const JarvisButton = ({
  children,
  variant = "contained",
  size = "medium",
  sx = {},
  disableStartIcon = true,
  disableEndIcon = false,
  endIcon = null,
  startIcon = null,
  disabled = false,
  animate = true,
  onClick = () => {},
  loading = false,
  product,
}) => {
  const classes = useStyles({ product });
  // console.log(product, "product");

  const getEndIcon = () => {
    if (disableEndIcon) {
      return null;
    }

    if (endIcon) {
      return endIcon;
    }

    return <ArrowRightIcon sx={{ fontSize: "16px !important" }} />;
  };

  const getStartIcon = () => {
    if (disableStartIcon) {
      return null;
    }

    if (startIcon) {
      return startIcon;
    }

    return <ArrowLeftIcon sx={{ fontSize: "16px !important" }} />;
  };

  return (
    <Button
      disableRipple={false}
      disabled={disabled}
      variant={variant}
      startIcon={getStartIcon()}
      endIcon={getEndIcon()}
      sx={{
        boxShadow: "none !important",
        ...sx,
      }}
      classes={{
        root: animate ? classes.rootAnimate : classes.root,
        contained: classes.contained,
        outlined: classes.outlined,
        callsContained: classes.callsContained,
        callsContained2: classes.callsContained2,
      }}
      onClick={onClick}
      size={size}
      children={children}
      loading={loading}
    />
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      // Add any base styles here
    },
    rootAnimate: {
      "& .MuiButton-endIcon": {
        transition: "all 0.2s linear",
      },
      "& .MuiButton-startIcon": {
        transition: "all 0.2s linear",
      },
      "&:hover": {
        "& .MuiButton-endIcon": {
          transform: "rotate(-45deg)",
        },
        "& .MuiButton-startIcon": {
          transform: "rotate(45deg)",
        },
      },
    },
    contained: (props) => ({
      background:
        props.product === "onestock"
          ? "linear-gradient(156deg, #3D8DFF 10.26%, #0B55CF 55.03%, #001A5C 112.02%)"
          : props.product === "portfolio"
          ? "linear-gradient(184deg, #6D4BD3 46.28%, #2E077E 103.94%)"
          : props.product === "protect"
          ? "linear-gradient(151deg, #07B589 23.47%, #00795A 62.11%, #194336 112.29%)"
          : props.product === "prime"
          ? "linear-gradient(90deg, #D3BF07 5.29%, #F8A515 78.33%), #FFF"
          : props.product === "sentiment" || props.product === "sentimentTracker"
          ? "linear-gradient(90deg, #161B23 -5.44%, #3D4971 51.74%, #161A22 103.68%), #FFF"
          : "#2B70C5",
      color: "white",
      "&:hover": {
        backgroundColor: "#151515",
        color: "white",
      },
      "&:disabled": {
        backgroundColor: "#dcdcdc !important",
      },
    }),
    outlined: {},
    callsContained: {
      backgroundColor: "#D44C4C",
      color: "white",
      border: "none",
      "&:hover": {
        backgroundColor: "#D44C4C",
        color: "white",
        border: "none",
      },
    },
    callsContained2: {
      backgroundColor: "#2B70C5",
      width: "25%",
      color: "white",
      "&:hover": {
        backgroundColor: "#202020",
        color: "white",
      },
      "&:disabled": {
        backgroundColor: "#dcdcdc !important",
      },
    },
  })
);

export default React.memo(JarvisButton);
